import { useOutletContext, useParams } from "react-router-dom";

import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import Tab from "ds/components/Tab";
import { useLayoutHeading } from "views/Account/Integrations/hooks/useLayoutHeading";
import { useLayoutMeta } from "views/Account/Integrations/hooks/useLayoutMeta";
import { IntegrationsOutletContext } from "views/Account/Integrations/types";

const useIntegrationsLayout = () => {
  const {
    deliveryId,
    integrationId: webhookId,
    statusCode,
  } = useParams<{
    deliveryId: string;
    integrationId: string;
    statusCode: string;
  }>();
  const { integration } = useOutletContext<IntegrationsOutletContext>();

  useBreadcrumbs([
    {
      title: "Integrations",
      link: "/integrations",
    },
    {
      title: integration.name,
      link: `/integrations/${integration.id}`,
    },
    {
      title: webhookId ?? "",
      link: `/integrations/${integration.id}/${webhookId}`,
    },
    {
      title: `${deliveryId} · ${statusCode}`,
    },
  ]);

  const webhookUrl = `/integrations/webhooks/${webhookId}/delivery/${deliveryId}/${statusCode}`;

  useLayoutMeta(
    <ViewHeaderNavigation>
      <Tab end to={webhookUrl} label="Request" />
      <Tab to={`${webhookUrl}/response`} label="Response" />
    </ViewHeaderNavigation>
  );

  useLayoutHeading(`${deliveryId}/${statusCode}`);
  return null;
};

export default useIntegrationsLayout;
